import React from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Copy from 'assets/copy.svg';
import {FormattedMessage} from "react-intl";

interface ReleaseCodeProps {
  id?: string;
  ean?: string | null;
}

export const ReleaseCode: React.FC<ReleaseCodeProps> = props => {
  const { id = '-', ean = '-' } = props;

  const onClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <Container onClick={onClick}>
      <Row>
        <FormattedMessage
          id="Releases.ReleaseCode.ReleaseID"
          defaultMessage="Release ID"
        />:
        <Value>{id || '-'}</Value>
        <CopyToClipboard text={id}><Copy /></CopyToClipboard>
      </Row>
      <Row>
        <FormattedMessage
          id="Releases.ReleaseCode.EAN"
          defaultMessage="EAN"
        />:
        <Value>{ean || '-'}</Value>
        {!!ean && <CopyToClipboard text={ean}><Copy /></CopyToClipboard>}
      </Row>
    </Container>
  );
};

export const Container = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Value = styled.div`
  font-weight: 600;
`;
